import AuditTrailsPageView from "./AuditTrailsPageView";

function AuditTrailsPage() {
  return <AuditTrailsPageView />;
}

export default AuditTrailsPage;
